// src/components/Login.js
import React, { useState } from 'react';
import { auth } from '../../Config/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import "./styles.scss"

const Login = ({switchLogin,closeTitleScreen}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      closeTitleScreen()
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        {/* <h2 className="login-title">
          Login
        </h2> */}
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        <form className="login-form" onSubmit={handleLogin}>
          <div className="form-group">
            {/* <label htmlFor="email" className="form-label">
              Email address
            </label> */}
            <input
              id="email"
              type="email"
               placeholder='Email'
              required
              className="login-form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            {/* <label htmlFor="password" className="form-label">
              Password
            </label> */}
            <input
              id="password"
              type="password"
              placeholder='Password'
              required
              className="login-form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="login-button"
          >
            Login
          </button>
          <div className="signup-prompt">
            <div className='link-button' onClick={()=>switchLogin("create")}>Create an account</div>|
            <div className='link-button' onClick={()=>switchLogin("forgot")}>Forgot your password</div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;